var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankNote01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Line/Finance/bank-note-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9 16.5V22.5M27 13.5V19.5M25.5 6C29.1731 6 31.1597 6.56214 32.1482 6.99816C32.2798 7.05623 32.3456 7.08526 32.5356 7.26656C32.6495 7.37523 32.8573 7.69409 32.9108 7.84213C33 8.08911 33 8.22411 33 8.49411V24.6167C33 25.9799 33 26.6614 32.7956 27.0118C32.5876 27.3682 32.3871 27.5338 31.9979 27.6708C31.6153 27.8054 30.8429 27.657 29.2983 27.3602C28.2171 27.1525 26.9348 27 25.5 27C21 27 16.5 30 10.5 30C6.82694 30 4.8403 29.4379 3.85182 29.0018C3.72018 28.9438 3.65437 28.9147 3.4644 28.7334C3.35053 28.6248 3.14268 28.3059 3.0892 28.1579C3 27.9109 3 27.7759 3 27.5059L3 11.3833C3 10.0201 3 9.33855 3.20442 8.98822C3.41235 8.63185 3.61289 8.46617 4.00209 8.32922C4.3847 8.19458 5.15705 8.34298 6.70174 8.63977C7.78293 8.84751 9.06522 9 10.5 9C15 9 19.5 6 25.5 6ZM21.75 18C21.75 20.0711 20.0711 21.75 18 21.75C15.9289 21.75 14.25 20.0711 14.25 18C14.25 15.9289 15.9289 14.25 18 14.25C20.0711 14.25 21.75 15.9289 21.75 18Z",
    stroke: "#00BC85",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNote01);
export default __webpack_public_path__ + "static/media/bank-note-01.1805f124a9a2596e5a81fb6a47b5857b.svg";
export { ForwardRef as ReactComponent };